import CustomNoDataBox from './customNoDataBox'
export default CustomNoDataBox
